import { Gear } from 'phosphor-react';

import { Button } from 'components/Button';
import { GatsbyLink } from 'components/Links';
import { FlexContainer } from 'components/FlexContainer';
import { Box } from 'components/Box';

import { BannerContainer, Header, Text } from '../styled/Container.styled';

import type { FC } from 'react';
import type { CookieBannerProps } from '../types';

export const CookieBanner: FC<CookieBannerProps> = ({
  onManagePreferencesClick,
  onRejectAll,
  onAcceptAll,
}) => (
  <BannerContainer>
    <Header>You are in control of your cookies</Header>
    <Text>
      We use cookies to make your experience better. By clicking Accept, you agree to our{' '}
      <GatsbyLink textColor="white" to="cookie-policy">
        Cookie Policy
      </GatsbyLink>
      .
    </Text>
    <Box marginBottom={5}>
      <Button
        onClick={onManagePreferencesClick}
        icon={<Gear weight="bold" aria-label="gear" />}
        iconDirection="left"
        appearance="tertiary"
        containerBackground="negative"
        title="Manage Preferences"
      >
        Manage Preferences
      </Button>
    </Box>

    <FlexContainer justifyContent="space-between" flexWrap="wrap" gap={4}>
      <Button
        onClick={onRejectAll}
        appearance="secondary"
        containerBackground="negative"
        title="Reject All"
      >
        Reject optional cookies
      </Button>
      <Button
        onClick={onAcceptAll}
        appearance="primary"
        containerBackground="negative"
        title="Accept All"
      >
        Accept all
      </Button>
    </FlexContainer>
  </BannerContainer>
);
